import * as React from 'react';
import {
    lazyIsCollabSpacePresent,
    lazyIsCollabAllowed,
    lazyGetShareLink,
    CollabSpaceBlockDialog,
    lazyGetConfirmationOptions,
} from 'owa-calendar-collaborative-space';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { trace } from 'owa-trace';

export async function validateCollabSpace(viewStateId: string): Promise<boolean> {
    let isValid: boolean = true;

    const isCollabSpacePresent = await lazyIsCollabSpacePresent.importAndExecute(viewStateId);
    const isCollabAllowed = await lazyIsCollabAllowed.importAndExecute(viewStateId);

    if (isCollabSpacePresent && isCollabAllowed) {
        const shareLink = await lazyGetShareLink.importAndExecute(viewStateId);
        try {
            if (new URL(shareLink)) {
                return isValid;
            }
        } catch {
            trace.warn('No valid fluid link present for the collaborative space');
            isValid = false;
        }
    }
    return isValid;
}

export async function collabSpaceConfirmation(viewStateId: string): Promise<DialogResponse> {
    const getConfirmationOptions = await lazyGetConfirmationOptions.import();

    // Passing the callback so that it can observe the store value.
    return confirm(() => getConfirmationOptions(viewStateId)?.title, undefined, false, {
        okText: () => getConfirmationOptions(viewStateId)?.okText,
        cancelText: () => getConfirmationOptions(viewStateId)?.cancelText,
        shouldDisableOkButton: () => getConfirmationOptions(viewStateId)?.shouldDisableOkButton,
        bodyElement: <CollabSpaceBlockDialog viewStateId={viewStateId} />,
    });
}
